/**
 * @file index.tsx
 * @module app/modules/warehouse/index
 * @description Implements the index workflow for warehouse management.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import Warehouse from './warehouse';
import CreateWarehouse from './create-warehouse';
import WarehouseDetail from './warehouse-detail';
import InterTransferRequest from './inter-transfer-request/inter-transfer-request';
import CreateInterTransferRequest from './inter-transfer-request/create-transfer-request';
import InterTransferDetail from './inter-transfer-request/inter-transfer-detail';
import AddGoodsToInventory from './inter-transfer-request/add-goods-to-inventory';
import EditWarehouse from './edit-warehouse';
import SendGoodsSeller from './inter-transfer-request/send-goods-seller';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
const warehouseBreadCrumbs: Array<PageLink> = [
  {
    title: 'Warehouse',
    path: '/warehouse',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const warehousev2BreadCrumbs: Array<PageLink> = [
  {
    title: 'Warehouse',
    path: '/warehouse',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Inter Transfer Requests',
    path: '/all-inter-transfer-request',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const WarehousePage = () => (
  <Routes>
    <Route element={<Outlet />} />
    <Route
      index
      element={<Navigate to="/warehouse/all-warehouse" />}
    />
    <Route
      path="all-warehouse"
      element={
        <>
          <PageTitle breadcrumbs={warehouseBreadCrumbs}>
            All Warehouse
          </PageTitle>
          <Warehouse />
        </>
      }
    />
    <Route
      path="all-inter-transfer-request/add-goods-to-inventory"
      element={
        <>
          <PageTitle breadcrumbs={warehousev2BreadCrumbs}>
            Add Goods to Inventory
          </PageTitle>
          <AddGoodsToInventory />
        </>
      }
    />
    <Route
      path="all-warehouse/create-warehouse"
      element={
        <>
          <PageTitle breadcrumbs={warehouseBreadCrumbs}>
            Create Warehouse
          </PageTitle>
          <CreateWarehouse />
        </>
      }
    />
    <Route
      path="all-warehouse/warehouse-details"
      element={
        <>
          <PageTitle breadcrumbs={warehouseBreadCrumbs}>
            Warehouse Details
          </PageTitle>
          <WarehouseDetail />
        </>
      }
    />
    <Route
      path="all-inter-transfer-requests"
      element={
        <>
          <PageTitle breadcrumbs={warehouseBreadCrumbs}>
            Inter Transfer Requests
          </PageTitle>
          <InterTransferRequest />
        </>
      }
    />
    <Route
      path="create-transfer-request"
      element={
        <>
          <PageTitle breadcrumbs={warehouseBreadCrumbs}>
            Create Transfer Request
          </PageTitle>
          <CreateInterTransferRequest />
        </>
      }
    />
    <Route
      path="all-inter-transfer-request/inter-transfer-details"
      element={
        <>
          <PageTitle breadcrumbs={warehousev2BreadCrumbs}>
            Inter Transfer Request Details
          </PageTitle>
          <InterTransferDetail />
        </>
      }
    />
    <Route
      path="edit-warehouse-details"
      element={
        <>
          <PageTitle breadcrumbs={warehouseBreadCrumbs}>
            Edit Warehouse Details
          </PageTitle>
          <EditWarehouse />
        </>
      }
    />
    <Route
      path="all-inter-transfer-request/send-goods-seller"
      element={
        <>
          <PageTitle breadcrumbs={warehousev2BreadCrumbs}>
            Send Goods to Seller
          </PageTitle>
          <SendGoodsSeller />
        </>
      }
    />
  </Routes>
);
export default WarehousePage;
